import { createFileRoute, redirect } from '@tanstack/react-router';

// Página antiga de cards (sessões/tokens/skills/memória) aposentada — o módulo
// Agentes (gestão) a substitui. Mantém o redirect pra não quebrar links antigos.
export const Route = createFileRoute('/_authed/agents')({
  beforeLoad: () => {
    throw redirect({ to: '/agentes/visao-geral' });
  },
});
